import React = require('react');
import { IResult } from '../../data/data';
import { CardTitle } from './CardTitle';
import { CardSummary } from './CardSummary';
import { CardMeta, MetaTypes, IMeta } from './CardMeta';
import { Card } from './Card';
import { SearchBoxContainer } from '../container/SearchBoxContainer';
import { PaginationContainer } from '../container/PaginationContainer';
import { NotificationBarContainer } from '../container/NotifcationBarContainer';
import { IMainProps } from '../container/ContentBySearchContainer';

export class Main extends React.Component<IMainProps, {}> {
  public constructor(props: IMainProps) {
    super(props);
    this.props.importEnv();
  }

  private meta = (
    lastModified: string,
    primaryUser: string,
    fileExtension: string,
    isDocument: boolean
  ): IMeta[] => {
    let result: IMeta[] = [];
    if (lastModified != null) {
      result.push({
        key: 'last modified',
        value: new Date(lastModified).toLocaleDateString(),
        type: MetaTypes.text
      });
    }
    if (primaryUser != null) {
      result.push({ key: 'user', value: primaryUser, type: MetaTypes.text });
    }
    if (isDocument) {
      result.push({
        key: 'file type',
        value: fileExtension,
        type: MetaTypes.text
      });
    }
    return result;
  };

  public render(): React.ReactElement<IMainProps> {
    return (
      <div>
        <SearchBoxContainer />
        <NotificationBarContainer />
        <div className="wpo ui empty divider" />
        <div className="wpo ui centered borderless panel p-search-result">
          <section className="wpo ui responsive two-column grid">
            {this.props.items.map((item: IResult, index) => {
              return (
                <article key={index} className="wpo ui clickable item">
                  <Card url={item.path}>
                    <CardTitle
                      title={item.title}
                      maxLength={30}
                      icon={item.icon}
                    />
                    <CardSummary text={item.description} maxLength={200} />
                    <CardMeta
                      meta={this.meta(
                        item.lastModified,
                        item.primaryUser,
                        item.fileExtension,
                        item.isDocument
                      )}
                    />
                  </Card>
                </article>
              );
            })}
          </section>
        </div>
        <div className="wpo ui empty divider" />
        <PaginationContainer />
        <div className="wpo ui empty divider" />
      </div>
    );
  }
}
